import NavigationBar from "../components/navigationBar";
import AboutMeComponent from "../components/aboutMeComponent";
import FooterView from "../components/footerView";


export default function AboutMe() {


    return (
        <div>
            <NavigationBar />
            <AboutMeComponent />
            <FooterView />
        </div>
    )
}